import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, DatePicker, Input, Modal, Row, Select, message } from "antd"
import { DeleteOutlined } from '@ant-design/icons'
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import _ from 'lodash'

interface Prop {
    customerID?: string
    storeID?: string
    onChange: () => void
}

interface employeeList {
    "employee_id": string,
    "user_name": string
}

interface itemList {
    "order_id": string,
    "item_id": string,
    "item_name": string,
    "item_manual_cost": number
    "item_settlement_amount": number
}

interface reciveRow {
    order_id: undefined | string, // 订单标识
    order_source_type: undefined | number, // 订单类型
    item_info: undefined | string,
    item_id: undefined | string, // 项目标识
    consume_count: undefined | number, // 消耗次数
    consume_manual_cost: undefined | number, // 消耗手工费
    consume_settlement_amount: undefined | number, // 消耗结转金额
    employee_recover: undefined | string,
    employee_id_recover: undefined | string, // 产康师标识
    employee_name_recover: undefined | string, // 产康师名称
    employee_teacher: undefined | string,
    employee_id_teacher: undefined | string, // 产康老师标识
    employee_name_teacher: undefined | string, // 产康老师名称
    service_date: undefined | string, // 服务日期
}

const { Option } = Select

export default function (prop: Prop) {

    const param: { id: string } = useParams()
    const [visible, setVisible] = useState<boolean>(false)

    const [recoverEmployeeList, setRecoverEmployeeList] = useState<employeeList[]>([])
    const [teacherEmployeeList, setTeacherEmployeeList] = useState<employeeList[]>([])
    const [itemList, setItemList] = useState<itemList[]>([])

    let reciveConsumeRow: reciveRow = {
        order_id: undefined,
        order_source_type: undefined,
        item_info: undefined,
        item_id: undefined,
        consume_count: 1,
        consume_manual_cost: undefined,
        consume_settlement_amount: undefined,
        employee_recover: undefined,
        employee_id_recover: undefined,
        employee_name_recover: undefined,
        employee_teacher: undefined,
        employee_id_teacher: undefined,
        employee_name_teacher: undefined,
        service_date: undefined
    }

    const [reciveConsumeData, setReciveConsumeData] = useState<reciveRow[]>([{
        order_id: undefined,
        order_source_type: undefined,
        item_info: undefined,
        item_id: undefined,
        consume_count: 1,
        consume_manual_cost: undefined,
        consume_settlement_amount: undefined,
        employee_recover: undefined,
        employee_id_recover: undefined,
        employee_name_recover: undefined,
        employee_teacher: undefined,
        employee_id_teacher: undefined,
        employee_name_teacher: undefined,
        service_date: undefined
    }])

    useEffect(() => {
        if (prop.storeID) {
            // 初始化产康师列表
            baseAxiosNoInfo('/global/employee_list_by_position', {
                params: {
                    department_id: prop.storeID,
                    position_number: 5
                }

            }).then((res: any) => {
                if (res) {
                    setRecoverEmployeeList(res)
                }
            })

            // 初始化产康老师列表
            baseAxiosNoInfo('/global/employee_list_by_position', {
                params: {
                    department_id: prop.storeID,
                    position_number: 28
                }

            }).then((res: any) => {
                if (res) {
                    setTeacherEmployeeList(res)
                }
            })
        }
    }, [prop.storeID])

    const addMoreRow = () => {
        setReciveConsumeData([...reciveConsumeData, reciveConsumeRow])
    }

    const deleteRow = (index: number) => {
        if (reciveConsumeData.length > 1) {
            let reciveD = _.cloneDeep(reciveConsumeData)
            reciveD.splice(index, 1)

            setReciveConsumeData(reciveD)
        }
    }

    const handleChange = (index: number, attr: string, value: any) => {
        let reciveD: any = _.cloneDeep(reciveConsumeData)
        reciveD[index][attr] = value

        // 选择订单类型
        if (attr == 'order_source_type') {
            reciveD[index]["order_id"] = ''
            reciveD[index]["item_info"] = ''
            reciveD[index]["item_id"] = ''
            reciveD[index]["consume_manual_cost"] = ''
            reciveD[index]["consume_settlement_amount"] = ''

            baseAxiosNoInfo('/chankang_center/customer/item', {
                params: {
                    customer_id: param.id,
                    order_type: value
                }

            }).then((res: any) => {
                if (res) {
                    setItemList(res)
                }
            })
        }

        // 选择项目
        if (attr == 'item_info') {
            reciveD[index]["consume_manual_cost"] = ''
            reciveD[index]["consume_settlement_amount"] = ''

            reciveD[index]["order_id"] = value.split("&")[0] != 'null' ? value.split("&")[0] : ''
            reciveD[index]["item_id"] = value.split("&")[1]

            if (reciveD[index]["order_source_type"] == 1) {
                reciveD[index]["consume_settlement_amount"] = value.split("&")[3]

            } else {
                reciveD[index]["consume_manual_cost"] = value.split("&")[2]
            }
        }

        // 选择产康师
        if (attr == 'employee_recover') {
            reciveD[index]["employee_id_recover"] = value.split("&")[0]
            reciveD[index]["employee_name_recover"] = value.split("&")[1]
        }

        // 选择产康老师
        if (attr == 'employee_teacher') {
            reciveD[index]["employee_id_teacher"] = value.split("&")[0]
            reciveD[index]["employee_name_teacher"] = value.split("&")[1]
        }

        setReciveConsumeData(reciveD)
    }

    const onFinish = () => {
        baseAxiosComplete.post('/chankang_center/customer/batch_consume', {
            customer_id: param.id,
            item_consume_detail: reciveConsumeData

        }).then(res => {
            if (res.status === 0) {
                message.success(`录入成功`)
                setVisible(false)
                prop.onChange()

                setReciveConsumeData([{
                    order_id: undefined,
                    order_source_type: undefined,
                    item_info: undefined,
                    item_id: undefined,
                    consume_count: 1,
                    consume_manual_cost: undefined,
                    consume_settlement_amount: undefined,
                    employee_recover: undefined,
                    employee_id_recover: undefined,
                    employee_name_recover: undefined,
                    employee_teacher: undefined,
                    employee_id_teacher: undefined,
                    employee_name_teacher: undefined,
                    service_date: undefined
                }])
            }
        })
    }

    return <Fragment>
        {/* 产康中心 -> 产康客户管理 -> 产康客户列表 -> 客户详情 -> 录入消耗 */}
        <Button type="primary" style={{ marginLeft: 10 }} size="small" onClick={() => { setVisible(true) }}>录入消耗</Button>

        <Modal title="录入消耗" width={1200} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
        <Button onClick={addMoreRow} size="small" type="primary">添加项目</Button>
        
            <Row style={{ marginTop: 5, marginBottom: 16 }} gutter={8} justify="space-around">
                <Col span={3}>日期<span style={{ color: "red" }}>*</span></Col>
                <Col span={3}>订单类型<span style={{ color: "red" }}>*</span></Col>
                <Col span={4}>项目名称<span style={{ color: "red" }}>*</span></Col>
                <Col span={2}>消耗次数<span style={{ color: "red" }}>*</span></Col>
                <Col span={2}>手工费</Col>
                <Col span={2}>结转金额</Col>
                <Col span={3}>产康师</Col>
                <Col span={3}>产康老师</Col>
                <Col span={1}></Col>
            </Row>

            {reciveConsumeData.map((el, index: number) =>
                <Row gutter={8} justify="space-around" style={{ marginBottom: 8, userSelect: 'none' }}>
                    <Col span={3}>
                        <DatePicker onChange={(v: any) => {
                            handleChange(index, 'service_date', v.format('YYYY-MM-DD'))
                        }} />
                    </Col>
                    <Col span={3}>
                        <Select value={el.order_source_type} style={{ width: '100%' }} onChange={(v: number) => {
                            handleChange(index, 'order_source_type', v)
                        }}>
                            <Option key={1} value={1}>产康购买</Option>
                            <Option key={2} value={2}>产康赠送</Option>
                            <Option key={3} value={3}>月子赠送</Option>
                            <Option key={4} value={4}>月子套餐</Option>
                        </Select>
                    </Col>
                    <Col span={4}>
                        <Select value={el.item_info} style={{ width: '100%' }} showSearch
                            filterOption={(input, option) => (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())}
                            onChange={(v: string) => { handleChange(index, 'item_info', v) }}
                        >
                            {itemList.map((el: itemList) => <Option value={el.order_id + '&' + el.item_id + '&' + el.item_manual_cost + '&' + el.item_settlement_amount} key={el.item_name}>{el.item_name}</Option>)}
                        </Select>
                    </Col>
                    <Col span={2}>
                        <Input value={el.consume_count} onChange={(v) => {
                            handleChange(index, 'consume_count', v.target.value)
                        }} />
                    </Col>
                    <Col span={2}>
                        <Input value={el.consume_manual_cost} onChange={(v) => {
                            handleChange(index, 'consume_manual_cost', v.target.value)
                        }} />
                    </Col>
                    <Col span={2}>
                        <Input value={el.consume_settlement_amount} onChange={(v) => {
                            handleChange(index, 'consume_settlement_amount', v.target.value)
                        }} />
                    </Col>
                    <Col span={3}>
                        <Select value={el.employee_recover} style={{ width: '100%' }} showSearch
                            filterOption={(input, option) => (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())}
                            onChange={(v: string) => { handleChange(index, 'employee_recover', v) }}
                        >
                            {recoverEmployeeList.map((el: employeeList) => <Option value={el.employee_id + '&' + el.user_name} key={el.user_name}>{el.user_name}</Option>)}
                        </Select>
                    </Col>

                    <Col span={3}>
                        <Select value={el.employee_teacher} style={{ width: '100%' }} showSearch
                            filterOption={(input, option) => (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())}
                            onChange={(v: string) => { handleChange(index, 'employee_teacher', v) }}
                        >
                            {teacherEmployeeList.map((el: employeeList) => <Option value={el.employee_id + '&' + el.user_name} key={el.user_name}>{el.user_name}</Option>)}
                        </Select>
                    </Col>

                    <Col span={1} style={{ paddingTop: 4 }}>
                        <DeleteOutlined onClick={() => {
                            deleteRow(index)
                        }} style={{ cursor: 'pointer' }} />
                    </Col>
                </Row>
            )}
        </Modal>
    </Fragment>
}